export { default as AdminManagementLayout } from './admin-management-layout';
